module.exports = __webpack_public_path__ + "media/images/facility-4ec51e3b4b7497a44e0517059b5968d2.svg";